module.exports = __webpack_public_path__ + "static/media/asaas-symbol.06c57816.svg";